<template>
  <el-dialog title="删除页面" :visible="visible" width="540px" top="8vh" append-to-body
             custom-class="editor-page-removal" :close-on-click-modal="false"
             @open="focusCancel" @opened="focusCancel" @close="close">
    <div class="editor-page-removal__content">
      <p>删除“{{ pageName }}”及其中的全部组件？</p>
      <p class="editor-page-removal__hint">删除会随草稿保存，当前编辑会话内可撤销；已发布内容在更新发布前保持不变。</p>
      <p v-if="blockedReason" class="editor-page-removal__error" role="alert">{{ blockedReason }}</p>
      <ul v-if="validContext && state.references.length" class="editor-page-removal__references" aria-label="引用此页的组件">
        <li v-for="(reference, index) in state.references" :key="index">
          <strong>{{ reference.pageName }} / {{ reference.componentName }}</strong>
          <span>{{ reference.label }}</span>
        </li>
      </ul>
      <el-form v-if="validContext && state.isHome && state.remainingPages.length" label-position="top">
        <el-form-item label="替代首页" required>
          <el-select v-model="replacementHomeId" placeholder="请选择删除后使用的首页" aria-label="替代首页">
            <el-option v-for="page in state.remainingPages" :key="page.id" :label="page.name" :value="page.id" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button ref="cancel" @click="close">取消</el-button>
      <el-button type="danger" :disabled="!!blockedReason || submitting" @click="confirm">删除页面</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { pageDeletionState } from '@/editor/core/page-deletion'

export default {
  inject: ['contain'],
  props: { visible: Boolean, pageId: { type: String, required: true } },
  data () {
    return {
      projectId: this.contain.id, project: this.contain.pageProject,
      page: this.contain.pageProject.pages.find(page => page.id === this.pageId),
      pageContext: this.contain._pageTemplateContext, config: this.contain.config, nodes: this.contain.nav,
      replacementHomeId: '', submitting: false, submitError: ''
    }
  },
  computed: {
    pageName () { return this.page ? this.page.name : '当前页面' },
    validContext () { return this.matchesContext() },
    state () {
      return pageDeletionState(this.contain.pageProject, this.pageId, {
        activePageId: this.contain.activePageId, nodes: this.contain.nav, replacementHomeId: this.replacementHomeId
      })
    },
    blockedReason () {
      if (!this.validContext) return '页面已切换或重新载入，请关闭后重试。'
      if (this.contain.editorSaveReady === false || this.contain.editorVersionSwitching) return '页面正在载入或恢复版本，请完成后重试。'
      return this.state.error || this.submitError
    }
  },
  methods: {
    matchesContext () {
      return !!this.contain.projectRecord && this.contain.id === this.projectId &&
        this.contain.pageProject === this.project && this.contain.activePageId === this.pageId &&
        this.contain._pageTemplateContext === this.pageContext && this.contain.config === this.config && this.contain.nav === this.nodes &&
        !!this.page && this.contain.pageProject.pages.find(page => page.id === this.pageId) === this.page
    },
    focusCancel () { this.$nextTick(() => { if (this.$refs.cancel) this.$refs.cancel.$el.focus() }) },
    close () { this.$emit('update:visible', false) },
    confirm () {
      if (this._isDestroyed || !this.visible || this.submitting || !this.matchesContext() || this.blockedReason) return
      this.submitting = true
      if (!this.contain.deletePage(this.pageId, this.replacementHomeId)) {
        this.submitting = false
        this.submitError = '页面状态已变化，未删除，请关闭后重新检查。'
        return
      }
      this.close()
      this.$message.success('页面已删除，可通过撤销恢复')
    }
  }
}
</script>

<style lang="scss">
.editor-page-removal {
  max-width: calc(100vw - 32px);
  .el-dialog__body { padding-top: 0; padding-bottom: 0; }
  &__content { max-height: calc(84vh - 140px); overflow-y: auto; overscroll-behavior: contain; overflow-wrap: anywhere; scrollbar-width: none; }
  &__content::-webkit-scrollbar { display: none; }
  &__hint { color: #909399; line-height: 1.7; }
  &__error { color: #f56c6c; line-height: 1.7; }
  &__references { padding: 0; list-style: none; }
  &__references li { padding: 10px 0; border-bottom: 1px solid #90939940; }
  &__references strong, &__references span { display: block; line-height: 1.7; }
  &__references span { color: #909399; }
  .el-select { width: 100%; }
}
</style>
